module.exports = __webpack_public_path__ + "img/banner5.032fa1ea.jpg";